function getRunningProjectTabs(allCount: number, recommendedCount: number) {
  return [
    {
      label: 'Všetky',
      count: { value: allCount, color: '#121212', bgColor: '#E3E3E3' },
    },
    { label: 'Najkratšie obdobie' },
    { label: 'Najvyšší výnos' },
    {
      label: 'Odporúčané',
      count: { value: recommendedCount, color: '#FFFFFF', bgColor: '#7A0014' },
    },
  ]
}

export { getRunningProjectTabs }
